var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProfileHeaderNav',{attrs:{"profile":_vm.profile}}),_c('v-container',[(!_vm.profile)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('ProfileDetailsDisplay',{attrs:{"profile":_vm.profile}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }